/* eslint-disable import/order */
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { arjSettingsLoadingLimitsResource } from '@jira/router-resources__advanced-roadmaps-settings/src/arjSettingsLoadingLimitsResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { arjSettingsLoadingLimitsRoute } from '@jira/router-routes__advanced-roadmaps-settings-routes/src/arjSettingsLoadingLimitsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { LazyArjSettingsLoadingLimits, ArjSettingsLoadingLimits } from './ui/index.tsx';

export const arjSettingsLoadingLimitsRouteEntry: Route = createEntry(
	arjSettingsLoadingLimitsRoute,
	() => ({
		group: 'software',
		// eslint-disable-next-line no-restricted-syntax
		component: ArjSettingsLoadingLimits,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			arjSettingsLoadingLimitsResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyArjSettingsLoadingLimits],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
